import { render, staticRenderFns } from "./TableDetailTransactions.vue?vue&type=template&id=87d9aaac&"
import script from "./TableDetailTransactions.vue?vue&type=script&lang=js&"
export * from "./TableDetailTransactions.vue?vue&type=script&lang=js&"
import style0 from "./TableDetailTransactions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports